var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "attendance-table-container" },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "sk-table custom-attendance-table",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.items,
            border: "",
            "max-height": _vm.$tableMaxHeight,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "selection",
              width: "50",
              align: "center",
              fixed: "left",
            },
          }),
          _c("el-table-column", {
            attrs: {
              type: "index",
              label: "STT",
              width: "55",
              align: "center",
              fixed: "left",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "Học sinh",
              prop: "nameStudent",
              "min-width": "180",
              fixed: "left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", { staticClass: "student-profile-cell" }, [
                      _c("span", { staticClass: "student-name-text" }, [
                        _vm._v(_vm._s(row.nameStudent)),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c(
            "el-table-column",
            { attrs: { label: "Thông tin điểm danh", align: "center" } },
            [
              _c("el-table-column", {
                attrs: { label: "Đi học", width: "105", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c(
                          "span",
                          { staticClass: "second-title title-present" },
                          [_vm._v("Đi học")]
                        ),
                        _c(
                          "div",
                          { staticClass: "header-checkbox-wrapper" },
                          [
                            _c("el-checkbox", {
                              attrs: {
                                indeterminate: _vm.isIndeterminate("PRESENT"),
                                value: _vm.isCheckAll("PRESENT"),
                              },
                              on: {
                                change: (val) =>
                                  _vm.onCheckAllChange(val, "PRESENT"),
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "div",
                          { staticClass: "status-cell" },
                          [
                            _c("el-checkbox", {
                              attrs: {
                                value: _vm.isCheckedStatus(row, "PRESENT"),
                              },
                              on: {
                                change: (val) =>
                                  _vm.onStatusCheckboxEl(val, row, "PRESENT"),
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Có phép", width: "105", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c(
                          "span",
                          { staticClass: "second-title title-absent-cp" },
                          [_vm._v("Có phép")]
                        ),
                        _c(
                          "div",
                          { staticClass: "header-checkbox-wrapper" },
                          [
                            _c("el-checkbox", {
                              attrs: {
                                indeterminate: _vm.isIndeterminate("ABSENT_CP"),
                                value: _vm.isCheckAll("ABSENT_CP"),
                              },
                              on: {
                                change: (val) =>
                                  _vm.onCheckAllChange(val, "ABSENT_CP"),
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "div",
                          { staticClass: "status-cell" },
                          [
                            _c("el-checkbox", {
                              attrs: {
                                value: _vm.isCheckedStatus(row, "ABSENT_CP"),
                              },
                              on: {
                                change: (val) =>
                                  _vm.onStatusCheckboxEl(val, row, "ABSENT_CP"),
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Không phép", width: "105", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c(
                          "span",
                          { staticClass: "second-title title-absent-kp" },
                          [_vm._v("Không phép")]
                        ),
                        _c(
                          "div",
                          { staticClass: "header-checkbox-wrapper" },
                          [
                            _c("el-checkbox", {
                              attrs: {
                                indeterminate: _vm.isIndeterminate("ABSENT_KP"),
                                value: _vm.isCheckAll("ABSENT_KP"),
                              },
                              on: {
                                change: (val) =>
                                  _vm.onCheckAllChange(val, "ABSENT_KP"),
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "div",
                          { staticClass: "status-cell" },
                          [
                            _c("el-checkbox", {
                              attrs: {
                                value: _vm.isCheckedStatus(row, "ABSENT_KP"),
                              },
                              on: {
                                change: (val) =>
                                  _vm.onStatusCheckboxEl(val, row, "ABSENT_KP"),
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Giờ đến", width: "115", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm.currentStatus(row) === "PRESENT"
                          ? _c("el-time-picker", {
                              staticClass: "custom-time-picker",
                              attrs: {
                                value: _vm.getTime(row, "arriveTime"),
                                "value-format": "HH:mm",
                                format: "HH:mm",
                                size: "mini",
                                "picker-options": {
                                  selectableRange: "00:00:00 - 23:59:59",
                                },
                                placeholder: "--:--",
                              },
                              on: {
                                input: (val) =>
                                  _vm.onTimeChange(val, row, "arriveTime"),
                              },
                            })
                          : _c("span", { staticClass: "text-disabled" }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Giờ về", width: "115", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("span", { staticClass: "second-title" }, [
                          _vm._v("Giờ về"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "header-checkbox-wrapper" },
                          [
                            _c("el-checkbox", {
                              attrs: {
                                indeterminate: _vm.isLeaveTimeIndeterminate(),
                                value: _vm.isLeaveTimeCheckAll(),
                              },
                              on: { change: _vm.onCheckAllLeaveTime },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm.currentStatus(row) === "PRESENT"
                          ? _c("el-time-picker", {
                              staticClass: "custom-time-picker",
                              attrs: {
                                value: _vm.getTime(row, "leaveTime"),
                                "value-format": "HH:mm",
                                format: "HH:mm",
                                size: "mini",
                                "picker-options": {
                                  selectableRange: "00:00:00 - 23:59:59",
                                },
                                placeholder: "--:--",
                              },
                              on: {
                                input: (val) =>
                                  _vm.onTimeChange(val, row, "leaveTime"),
                              },
                            })
                          : _c("span", { staticClass: "text-disabled" }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Đi muộn", width: "95", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.arrivingLate
                          ? _c(
                              "span",
                              {
                                staticClass: "badge-minute badge-minute--late",
                              },
                              [_vm._v(_vm._s(row.arrivingLate) + " ph")]
                            )
                          : _c("span", { staticClass: "text-disabled" }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Đón muộn", width: "95", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.latePickup
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "badge-minute badge-minute--pickup",
                              },
                              [_vm._v(_vm._s(row.latePickup) + " ph")]
                            )
                          : _c("span", { staticClass: "text-disabled" }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "el-table-column",
            { attrs: { label: "Ăn", align: "center" } },
            [
              _c("el-table-column", {
                attrs: { label: "Sáng", width: "85", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("span", { staticClass: "second-title" }, [
                          _vm._v("Sáng"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "header-checkbox-wrapper" },
                          [
                            _c("el-checkbox", {
                              attrs: {
                                indeterminate:
                                  _vm.isMealIndeterminate("breakfast"),
                                value: _vm.isMealCheckAll("breakfast"),
                              },
                              on: {
                                change: (val) =>
                                  _vm.onCheckAllMealChange(val, "breakfast"),
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "div",
                          { staticClass: "status-cell" },
                          [
                            _vm.currentStatus(row) === "PRESENT"
                              ? _c("el-checkbox", {
                                  attrs: {
                                    value: _vm.getAttendanceEat(
                                      row,
                                      "breakfast"
                                    ),
                                  },
                                  on: {
                                    change: (val) =>
                                      _vm.onCheckAttendanceEat(
                                        val,
                                        row,
                                        "breakfast"
                                      ),
                                  },
                                })
                              : _c("span", { staticClass: "text-disabled" }, [
                                  _vm._v("-"),
                                ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Chính", width: "85", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("span", { staticClass: "second-title" }, [
                          _vm._v("Chính"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "header-checkbox-wrapper" },
                          [
                            _c("el-checkbox", {
                              attrs: {
                                indeterminate:
                                  _vm.isMealIndeterminate("mainMeal"),
                                value: _vm.isMealCheckAll("mainMeal"),
                              },
                              on: {
                                change: (val) =>
                                  _vm.onCheckAllMealChange(val, "mainMeal"),
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "div",
                          { staticClass: "status-cell" },
                          [
                            _vm.currentStatus(row) === "PRESENT"
                              ? _c("el-checkbox", {
                                  attrs: {
                                    value: _vm.getAttendanceEat(
                                      row,
                                      "mainMeal"
                                    ),
                                  },
                                  on: {
                                    change: (val) =>
                                      _vm.onCheckAttendanceEat(
                                        val,
                                        row,
                                        "mainMeal"
                                      ),
                                  },
                                })
                              : _c("span", { staticClass: "text-disabled" }, [
                                  _vm._v("-"),
                                ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Phụ", width: "85", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("span", { staticClass: "second-title" }, [
                          _vm._v("Phụ"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "header-checkbox-wrapper" },
                          [
                            _c("el-checkbox", {
                              attrs: {
                                indeterminate: _vm.isMealIndeterminate("snack"),
                                value: _vm.isMealCheckAll("snack"),
                              },
                              on: {
                                change: (val) =>
                                  _vm.onCheckAllMealChange(val, "snack"),
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "div",
                          { staticClass: "status-cell" },
                          [
                            _vm.currentStatus(row) === "PRESENT"
                              ? _c("el-checkbox", {
                                  attrs: {
                                    value: _vm.getAttendanceEat(row, "snack"),
                                  },
                                  on: {
                                    change: (val) =>
                                      _vm.onCheckAttendanceEat(
                                        val,
                                        row,
                                        "snack"
                                      ),
                                  },
                                })
                              : _c("span", { staticClass: "text-disabled" }, [
                                  _vm._v("-"),
                                ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Tối", width: "85", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("span", { staticClass: "second-title" }, [
                          _vm._v("Tối"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "header-checkbox-wrapper" },
                          [
                            _c("el-checkbox", {
                              attrs: {
                                indeterminate:
                                  _vm.isMealIndeterminate("dinner"),
                                value: _vm.isMealCheckAll("dinner"),
                              },
                              on: {
                                change: (val) =>
                                  _vm.onCheckAllMealChange(val, "dinner"),
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "div",
                          { staticClass: "status-cell" },
                          [
                            _vm.currentStatus(row) === "PRESENT"
                              ? _c("el-checkbox", {
                                  attrs: {
                                    value: _vm.getAttendanceEat(row, "dinner"),
                                  },
                                  on: {
                                    change: (val) =>
                                      _vm.onCheckAttendanceEat(
                                        val,
                                        row,
                                        "dinner"
                                      ),
                                  },
                                })
                              : _c("span", { staticClass: "text-disabled" }, [
                                  _vm._v("-"),
                                ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-table-column", {
            attrs: {
              label: "Tác vụ",
              align: "center",
              width: "260",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "div",
                      { staticClass: "action-buttons-wrapper" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "row-action-btn btn-save",
                            attrs: {
                              size: "mini",
                              type: "primary",
                              disabled: _vm.isButtonDisabled(row),
                              loading: _vm.saving,
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.saveAttendance(row)
                              },
                            },
                          },
                          [_vm._v("Lưu")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "row-action-btn btn-edit",
                            attrs: {
                              size: "mini",
                              type: "success",
                              disabled: _vm.isButtonEditDisabled(row),
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleUpdate(row)
                              },
                            },
                          },
                          [_vm._v("Sửa")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "row-action-btn btn-ai",
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.checkAI(row)
                              },
                            },
                          },
                          [_vm._v("Kiểm tra AI")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("CheckInformationAIDialog", {
        ref: "CheckInformationAIDialog",
        attrs: { dialogVisible: _vm.isOpenCheckInformationAIDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.closeCheckInformationAIDialog()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }